const KEY = 'pending-voucher-purchase';

export function savePendingVoucherPurchase() {
	localStorage.setItem(KEY, 'true');
}

export function getPendingVoucherPurchase(): boolean {
	return localStorage.getItem(KEY) === 'true';
}

export function clearPendingVoucherPurchase() {
	localStorage.removeItem(KEY);
}
